import { Accordion, AttachmentCommonUpload, InputField, Label, OutlineButton, Tabs, Tooltip } from 'client/CommonComponents';
import './TaskBulkOrder.scss'
import TaskGrid from './TaskGrid'
import TaskBulkOrderHeader from '../TaskBulkOrder/TaskBulkOrderHeader/TaskBulkOrderHeader-container'
import AssetItemStatus from '../AssetItemStatus'
import ChangeLog from '../../PurchaseOrder/ChangeLog';

const Task = (props: any) => {
    const {
        taskHeaderDetails,
        onChangeAccordian,
        orderDetailId,
        activeStepper,
        setCancelledItemFleetId,
        purchaseOrderStepperData
    } = props;

    let ExpandedItems: any = [];
    taskHeaderDetails?.map((item: any) => {
        const expandItem = {
            headerText: <TaskBulkOrderHeader item={item} purchaseOrderStepperData={purchaseOrderStepperData} />,
            content: <>
                <TaskGrid taskItemDetails={item?.taskItemDetails} orderDetailId={orderDetailId} taskHeaderDetails={item} fleetDetailId={item.fleetDetailId} purchaseOrderStepperData={purchaseOrderStepperData} />
                <div className='taskChangeLogAccord px-3'>
                    <Tabs tabItems={[
                        {
                            itemKey: "changelog-bukorderfleet",
                            headerText: "CHANGE LOG",
                            content:  <ChangeLog fleetRequestDetailId={item?.fleetDetailId} activeStepper={activeStepper} skipVendorDetail={false} setCancelledItemFleetId={setCancelledItemFleetId} />
                        },
                        {
                            itemKey: "assetitemstatus-bukorderfleet",
                            headerText: "ASSET ITEM STATUS",
                            content:  <AssetItemStatus skipVendorDetail = {false} fleetRequestDetailId={item?.fleetDetailId} isBulkOrder = {true}/>
                        },]} 
                     data-attribute="TaskBulkOrder_Default_Tabs" />              
                </div>
            </>,
            uuid: `Task_Accordion_${item.fleetDetailId}`,
        }
        ExpandedItems.push(expandItem);
    })
    return (
        <div className="Task-container">
            <Accordion
                Items={ExpandedItems}
                className="custom-accordion LeaderOrderAccordion"
                onChange={(item: any) => { onChangeAccordian(item) }}
             data-attribute="TaskBulkOrder_Default_Accordion" />
        </div>
    )
}

export default Task